(() => {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  const openDrawer = () => {
    if (!drawer.open) drawer.showModal();
  };
  const closeDrawer = () => drawer.close();
  const formatMoney = (cents, currency = window.SaltySailor.currency || 'USD') => new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency
  }).format((Number(cents) || 0) / 100);

  const renderCart = (cart) => {
    const itemsRoot = drawer.querySelector('[data-cart-items]');
    if (!itemsRoot) return;
    itemsRoot.replaceChildren();
    if (!cart.items.length) {
      const empty = document.createElement('p');
      empty.textContent = 'Your cart is empty. Let\'s fix that.';
      itemsRoot.append(empty);
      return;
    }
    cart.items.forEach((item) => {
      const article = document.createElement('article');
      article.className = 'cart-drawer__item';
      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        article.append(image);
      }
      const copy = document.createElement('div');
      const title = document.createElement('strong');
      title.textContent = item.product_title;
      const variant = document.createElement('span');
      variant.textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      const plan = document.createElement('span');
      plan.textContent = item.selling_plan_allocation?.selling_plan?.name || '';
      const price = document.createElement('span');
      price.textContent = formatMoney(item.final_line_price, cart.currency);
      copy.append(title, variant, plan, price);
      article.append(copy);
      itemsRoot.append(article);
    });
  };

  document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', openDrawer));
  drawer.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', closeDrawer));
  drawer.addEventListener('click', (event) => {
    if (event.target === drawer) closeDrawer();
  });

  document.addEventListener('salty:cart-added', async (event) => {
    const status = drawer.querySelector('[data-cart-status]');
    if (status) status.textContent = `${event.detail.title || 'Coffee'} added to your cart.`;
    try {
      const response = await fetch(`${window.SaltySailor.routes.cart}.js`, { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
      const total = drawer.querySelector('[data-cart-total]');
      if (total) total.textContent = formatMoney(cart.total_price, cart.currency);
      renderCart(cart);
    } catch (error) {
      console.warn('Cart count refresh failed.', error);
    }
    openDrawer();
  });
})();

(() => {
  const forms = document.querySelectorAll('[data-collection-add-form]');
  if (!forms.length) return;

  forms.forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('[data-collection-add]');
      if (!button || button.disabled) return;

      const originalLabel = button.textContent.trim();
      button.disabled = true;
      button.classList.remove('is-added', 'is-error');
      button.textContent = 'Adding...';

      try {
        const response = await fetch(window.SaltySailor.routes.cartAdd, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const item = await response.json();
        if (!response.ok) throw new Error(item.description || 'This coffee could not be added.');

        button.classList.add('is-added');
        button.textContent = 'Added to cart';
        document.dispatchEvent(new CustomEvent('salty:cart-added', {
          detail: { title: item.product_title || form.dataset.productTitle }
        }));
        window.setTimeout(() => {
          button.classList.remove('is-added');
          button.textContent = originalLabel;
          button.disabled = false;
        }, 1800);
      } catch (error) {
        button.classList.add('is-error');
        button.textContent = error.message || 'Try again';
        window.setTimeout(() => {
          button.classList.remove('is-error');
          button.textContent = originalLabel;
          button.disabled = false;
        }, 2800);
      }
    });
  });

  const sort = document.querySelector('[data-collection-sort]');
  sort?.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    window.location.assign(url.toString());
  });
})();
